import { AUTH_METHOD } from 'symbols';

export enum TYPE_ACTION {
  REGISTRATION = 'registration',
  RESET_PASSWORD = 'reset-password'
}

export interface LoginData {
  tel: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
}


export interface RegistrationData {
  tel?: string;
  username?: string;
  email?: string;
  password: string;
  firstName: string;
  lastName: string;
}

export interface CheckConfirmCodeModel {
  tel: string;
  confirmCode: string;
}

export interface ResetPasswordModel {
  password: string;
  confirmPassword: string;
}

export interface GpAuthConfigModel {
  authMethod: AUTH_METHOD;
}

export const GP_AUTH_CONFIG_DEFAULT: GpAuthConfigModel = {
  authMethod: AUTH_METHOD.TELEGRAM_BOT
};

export const GP_AUTH_CONFIG_TOKEN = 'GP_AUTH_CONFIG_TOKEN';

